import request from '../../../../../../api/request';
import { Discount, PostulationDetailDiscount } from './type';

const TARIFF_STEP = {
  SET_DISCOUNT: (postulationDetailId: number | string) =>
    `/maintainers-portal/tuition-process-steps/tariff/discounts/${postulationDetailId}/detail-discount`,
  DISCOUNTS: '/maintainers-portal/tuition-process-steps/tariff/discounts',
  GET_DISCOUNT: (postulationDetailId: number | string) =>
    `/maintainers-portal/tuition-process-steps/tariff/discounts/${postulationDetailId}/detail-discount`,
};

/**
 *Obtiene el listado de todos los descuentos
 */
export const getAllDiscounts = () => {
  return request<Discount[]>(TARIFF_STEP.DISCOUNTS);
};

export const getDiscountFromPostulationDetail = (
  postulationDetailId: number | string,
) => {
  return request<PostulationDetailDiscount[]>(
    TARIFF_STEP.GET_DISCOUNT(postulationDetailId),
  );
};

/**
 * guarda descuento a postulante
 */
export const saveDiscountPostulant = (
  postulationDetailId: number,
  data: {
    discountCode: string;
    discountName: string;
    discountValue: number;
    type: string;
  },
) => {
  return request<Discount>(TARIFF_STEP.SET_DISCOUNT(postulationDetailId), {
    method: 'POST',
    data,
  });
};
